import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsVelomobileNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M8.128 11h-.934c-.879 0-1.75-.159-2.573-.469l-.133-.05A2.25 2.25 0 010 10.287V4.337c0-.225.112-.462.342-.595C.644 3.566 1.84 3 4.64 3c2.602 0 5.149.786 7.157 1.912 1.98 1.11 3.555 2.62 4.045 4.157a1.381 1.381 0 01-.349 1.422c-.33.331-.802.509-1.277.509h-1.844a2.251 2.251 0 01-4.244 0zM2.512 4.393a6.379 6.379 0 00-1.262.304V8.75h.862c.878 0 1.75.159 2.572.469l.378.142a6.042 6.042 0 002.132.389h.862a2.25 2.25 0 014.388 0h1.773c.177 0 .32-.07.391-.141a.18.18 0 00.05-.077.141.141 0 00-.007-.083c-.346-1.088-1.587-2.391-3.454-3.44L10.272 7h-5.93zm.728 5.713A6.037 6.037 0 002.112 10h-.83a1 1 0 101.958.106zm.708-5.843L4.992 5.75h4.736l.303-.324C8.41 4.711 6.533 4.25 4.64 4.25c-.246 0-.476.005-.693.013zM10.25 9.25a1 1 0 100 2 1 1 0 000-2z"
        fill=""
      />
    </svg>
  )
);
SvgSportsVelomobileNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsVelomobileNormalXsmall;
